import React, { useEffect, useRef } from 'react'

const OutClick = (props) => {
  const elementRef = useRef();
  const { className, style, children, handleClick } = props;
  const _className = className ? className : "";
  const _style = style ? style : {};

  const stopClickPropagation = (evt) => {
    evt.stopPropagation()
  }

  useEffect(() => {
    const handleClickOutside = (evt) => {
      if (elementRef.current && !elementRef.current.contains(evt.target)) {
        handleClick(evt);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [] );

  return (
    <div ref={elementRef} className={_className} style={_style} onClick={stopClickPropagation}>
      { children }
    </div>
  );
}

export default OutClick



// WEBPACK FOOTER //
// ./src/views/components/outclick.js